import { useSelector } from 'react-redux';
import { ReduxState } from '../reducers';
import { FeatureFlag } from '@thingslog/repositories';

const useIsEnabledFeatureFlag = (featureFlag: FeatureFlag): boolean => {
  const featureFlags = useSelector((state: ReduxState) => state.featureFlags.featureFlagsArray);
  return featureFlags.includes(featureFlag);
};

export default useIsEnabledFeatureFlag;
